/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Pritish Barabde",
  title: "Hi, I'm Pritish Barabde",
  subTitle: emoji(
    "A Self-driven, Quick starter, Passionate programmer 🚀 with a curious mind who enjoys solving a complex and challenging real-world problems."
  ),
  subTitle1: emoji(
    "I am a Computer Engineering Grad from University Of Mumbai.",
  ),
  resumeLink:
    "https://drive.google.com/uc?export=download&id=1DZaA1idzg5P7ilJx9n1crmsEzuGTTLvx", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/pritishbarabde",
  linkedin: "https://www.linkedin.com/in/pritishbarabde/",
  gmail: "barabdepritish@gmail.com",
  facebook: "https://www.facebook.com/pritish.barabde",
  twitter: "https://twitter.com/PritishBarabde",
  instagram: "https://instagram.com/PritishBarabde",
  telegram: "https://t.me/pritishbarabde",
  // github: "https://github.com/saadpasta",
  // linkedin: "https://www.linkedin.com/in/saadpasta/",
  // gmail: "saadpasta70@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CN, AI etc."
    ),
    emoji("⚡ Apart from this, I have done courses on Deep Learning, Data Science, Computer Networking and Cyber Security."),
    emoji(
      "⚡ Attended Workshop on Machine Learning and Artificial Intelligence."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "HTML-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS-3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "C",
      fontAwesomeClassname: "fas fa-copyright"
    },
    {
      skillName: "SQL-Database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js-square"
    },
    {
      skillName: "GIT",
      fontAwesomeClassname: "fab fa-git-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "St. Francis Institute Of Management and Research",
      logo: require("./assets/images/sfimar-logo.png"),
      subHeader: "Master's in Management Studies in Systems",
      duration: "2024 - 2026",
      desc: "Mumbai. Maharashtra. India",
    //  descBullets: [""]
    },
    {
      schoolName: "St. John College of Engineering and Management",
      logo: require("./assets/images/sjcem-logo.png"),
      subHeader: "Bachelor of Engineering in Computer Science",
      duration: "2018 - 2022",
      desc: "Mumbai. Maharashtra. India",
    //  descBullets: [""]
    },
    {
      schoolName: "Utkarsha Vidyalaya & Junior College",
      logo: require("./assets/images/UtkarshaLogo.png"),
      subHeader: "HSC Maharashtra State Board: 11th - 12th",
      duration: "2016 - 2018",
      desc:
        "Mumbai. Maharashtra. India",
    //  descBullets: [""]
    },
    {
      schoolName: "N.G.Vartak English Medium High School & Junior College",
      logo: require("./assets/images/ngvlogo.png"),
      subHeader: "SSC Maharashtra State Board: 1st - 10th",
      duration: "2002 - 2016",
      desc:
        "Mumbai. Maharashtra. India",
    //  descBullets: [""]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Super Mario",
      progressPercentage: "100%"
    },
    {
      Stack: "Backend",
      progressPercentage: "50%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Data Analyst - Intern",
      company: "Switch My Loan",
      companylogo: require("./assets/images/smla.png"),
      date: "May 2025 – July 2025",
      // desc:
      //   "Predicted the percentage of an student based on the no. of study hours.",
      descBullets: [
        "Engaged in a hands-on data analysis focusing on real-world data structuring, integration, and analysis in a fintech environment.",
        "Gained practical experience in SQL and Python, leveraging these tools to clean datasets, automate workflows, and generate actionable insights for marketing and product teams.",
        "Contributed to data mapping and reporting processes using SQL JOINs, pivot tables, and data visualization techniques to support business decision-making.",
        "Collaborated cross-functionally while upholding professional standards, ensuring accuracy, efficiency, and integrity in all analytical tasks.",
      ]
    },
    {
      role: "Technical Associate",
      company: "Torque India",
      companylogo: require("./assets/images/tq.png"),
      date: "October 2023 – August 2024",
      // desc:
      //   "Predicted the percentage of an student based on the no. of study hours.",
      descBullets: [
        "Managed and maintained the entire e-commerce website and product listings using Shopify, ensuring smooth operations and an optimized user experience.",
        "Integrated multiple payment gateways to enhance checkout efficiency and provide customers with diverse and secure transaction options.",
        "Implemented WhatsApp automation workflows to streamline customer communication, improve engagement, and reduce manual follow-ups.",
        "Coordinated with cross-functional developer teams to design, build, and customize an internal ERP system from scratch aligned with business needs.",
        "Automated invoicing processes using Excel-based scripts and templates, significantly reducing manual effort and improving accuracy. ",
        "Created detailed business and performance reports, delivering actionable insights to support decision-making for operations, sales, and management teams."
      ]
    },
    {
      role: "Project Engineer",
      company: "Wipro",
      companylogo: require("./assets/images/Wipro_logo.png"),
      date: "March 2023 – August 2023",
      // desc:
      //   "Predicted the percentage of an student based on the no. of study hours.",
      descBullets: [
        "Actively participated in Wipro's comprehensive corporate training programs, specializing in corporate ethics, soft skills, punctuality, and discipline.",
        "Immersed in a curriculum fostering integrity, responsibility, and transparency, shaping my professional identity.",
        "Championed Wipro's core values, ensuring adherence to high ethical standards and transparency.",
        "Acquired soft skills for effective communication, collaboration, and adaptability.",
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/airmouse.gif"),
      projectName: "Air Mouse",
      projectDesc:"Made a system which uses hand gestures to controll the mouse functions.",
      projectDesc1:"It was built to replace a physical mouse with a virtual hand gesture controlled mouse.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/pritishbarabde/Air_Mouse"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/system.gif"),
      projectName: "Employee Management System",
      projectDesc:"Made a system which manages employees in an IT Company.",
      projectDesc1:"It was built by using HTML, CSS, Javascript & PHP.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/pritishbarabde/Employee_Management_System"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/form.gif"),
      projectName: "Seminar Attendance & Feedback Portal",
      projectDesc: "Made a portal which records attendance and feedback of students who attended the seminar.",
      projectDesc1:"It was built by using HTML, CSS, Javascript & PHP.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/pritishbarabde/Seminar_Attendance_And_Feedback_Portal"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Data Analytics",
      subtitle:
        "Google",
      image: require("./assets/images/googleanalytics.png"),
      footerLink: [
        {
          name: "Certification",
          url:"https://www.coursera.org/account/accomplishments/professional-cert/DM66M55SR6EZ"
        }
      ]
    },

    {
      title: "Introduction to Cybersecurity",
      subtitle: "Cisco",
      image: require("./assets/images/cyber.png"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/19pw1gduEb4xzBQL1TarCEP6dXH8V3WjQ/view?usp=sharing"},
    //    {
    //      name: "Final Project",
    //      url: "https://"
    //    }
      ]
    },

    {
      title: "Design Thinking for Innovation",
      subtitle:
        "University of Virginia",
      image: require("./assets/images/design_think_innovation.png"),
      footerLink: [
        {
          name: "Certification",
          url:
            "https://www.coursera.org/account/accomplishments/verify/JYPWYGE4VE2J"
        },
        
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url:
        "https://medium.com/@pritishbarabde/best-cashback-credit-cards-in-india-4e53a5a363db",
      title: "Best Cashback Credit Cards in India.",
      description:
        "Credit cards have become an integral part of our financial life. They offer convenience, ease of payment, and several rewards and benefits."
    },
    {
      url: "https://medium.com/@pritishbarabde/tableau-vs-power-bi-8af409e838ee",
      title: "Tableau vs Power BI",
      description:
        "In the world of data visualization tools, Tableau and Power BI are two of the most popular options available."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  location: "Mumbai,Maharashtra,India",
  // number: "+91-XXXXXXXXXX",
  email_address: "barabdepritish@gmail.com",
  designation: "Software Engineer"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
